var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3431 18.1579C19.2688 16.5948 20.5 14.2048 20.5 11.5263C20.5 6.81736 16.6944 3 12 3C7.30558 3 3.5 6.81736 3.5 11.5263C3.5 14.2048 4.73123 16.5948 6.65693 18.1579H17.3431Z",
    fill: "#9299A2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 19.5791,
    width: 17,
    height: 1.42105,
    fill: "#9299A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8227 12.0293H10.7525V13.0063H12.752V14.1257H10.7525V16.2629H9.65542V14.1257H8.22217V13.0063H9.65542V12.0293H8.22217V10.9098H9.65542V5.8418H12.8227C13.4951 5.8418 14.0496 5.98258 14.486 6.26413C14.9225 6.54569 15.2469 6.92054 15.4592 7.38867C15.6716 7.85681 15.7777 8.37243 15.7777 8.93555C15.7777 9.49866 15.6716 10.0143 15.4592 10.4824C15.2469 10.9506 14.9225 11.3254 14.486 11.607C14.0496 11.8885 13.4951 12.0293 12.8227 12.0293ZM10.7525 10.9098H12.8227C13.4597 10.9098 13.9316 10.7233 14.2383 10.3501C14.545 9.97697 14.6984 9.50545 14.6984 8.93555C14.6984 8.36565 14.545 7.89412 14.2383 7.52097C13.9316 7.14782 13.4597 6.96125 12.8227 6.96125H10.7525V10.9098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/topup.d3b858d6485a2e8930de7d56cd516bc5.svg";
export { ForwardRef as ReactComponent };